import React from "react";

import { GetTasksQueryParamsV4 } from "@fartherfinance/frontend/api/TaskWorkflows/requests/getTasks";
import { SortOrder } from "@fartherfinance/frontend/api/Types";

import {
  TASK_STATUSES_ACTIVE,
  TASK_STATUSES_ALL,
  TASK_STATUSES_COMPLETED,
  TASKS_DEFAULT_QUERY_PARAMS,
} from "../../../common";
import { useTasksFiltersV4 } from "../../../TasksFiltersContext";
import SegmentedButton from "@src/sharedComponents/SegmentedButton/SegmentedButton";

interface Props {
  handleApplyFilters: (
    newFilters: GetTasksQueryParamsV4,
    showTaskStatusPill: boolean
  ) => void;
}

const TaskStatusQuickSelect: React.FC<Props> = ({ handleApplyFilters }) => {
  const { taskStatusFilterCategory } = useTasksFiltersV4();

  return (
    <SegmentedButton
      selected={taskStatusFilterCategory}
      options={[
        {
          action: () => {
            handleApplyFilters(
              {
                filterByTaskStatus: TASK_STATUSES_ACTIVE,
                sort: TASKS_DEFAULT_QUERY_PARAMS.sort,
              },
              false
            );
          },
          key: "active",
          text: "Active",
        },
        {
          action: () => {
            handleApplyFilters(
              {
                filterByTaskStatus: TASK_STATUSES_COMPLETED,
                sort: `${SortOrder.Descending}updatedTs`,
              },
              false
            );
          },
          key: "completed",
          text: "Completed",
        },
        {
          action: () => {
            handleApplyFilters(
              {
                filterByTaskStatus: TASK_STATUSES_ALL,
                sort: `${SortOrder.Descending}updatedTs`,
              },
              false
            );
          },
          key: "all",
          text: "All",
        },
      ]}
    />
  );
};

export default TaskStatusQuickSelect;
